var defaultFlags = {
    /*
     * INCREMENT THE VERSION every time you make changes - [Major].[Minor].[Patch]
     * as a reminder for SemVer versioning standards, increment:
     * MAJOR version when you make incompatible API changes - changing existing flag names or structures
     * MINOR version when you add/remove functionality in a backward compatible manner - ie new flag added/removed
     * PATCH version when you make backward compatible bug fixes - switching flags on/off
     */
    version: '1.0.0',
    flags: {
        showForbearancePage: false
    }
};
export default defaultFlags;
//# sourceMappingURL=defaultFlags.js.map